export default __webpack_public_path__ + "static/media/nestedIcon.70492b65.svg";